module.exports = __webpack_public_path__ + "img/more_square.fd83141b.svg";